// The NAME of an environment variable the operator provides at install time. Every secret in
// a distribution config is such a name — an API key (`apiKeyEnvVar`), a service env value
// (`envVar`), a mock user's password (`passwordEnvVar`) — never the value: the value comes
// from the operator's environment (docker compose substitutes `${NAME}`, `admin apply` reads
// process.env), and the name is what `secrets.json` lists for the installer.
import { z } from 'zod';
export const EnvVarNameSchema = z.string().regex(/^[A-Z][A-Z0-9_]*$/, 'must be UPPER_SNAKE_CASE');
//# sourceMappingURL=env-var-name.js.map